<template>
  <div>
    <div style="float: right">
      <datetime-range
        id="custom-datetime-range"
        :allow-clear="false"
        :default-value="datetimeRange"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div
      class="module-container"
      style="height: 370px; margin: 16px 1px 0 1px"
    >
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <log-table :datetime-range="datetimeRange" :columns="columns" :get-func="getTableFunc"></log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getDataExchangeLogList, getDataExchangeTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import LogChartCard from './modules/LogChartCard.vue'
import LogTable from './modules/LogTable.vue'

export default {
  name: 'DataExchangeLog',
  components: {
    DatetimeRange,
    LogChartCard,
    LogTable
  },
  data () {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTrendFunc: getDataExchangeTrend,
      getTableFunc: getDataExchangeLogList,
      columns: [
        //  {
        //   dataIndex: 'timestamp',
        //   title: '采集时间',
        //   width: 200,
        //   scopedSlots: {
        //     customRender: 'timestamp'
        //   }
        // },
        // {
        //   dataIndex: 'hostip',
        //   title: 'IP 地址',
        //   width: 160,
        //   key: 'hostip',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon',
        //     customRender: 'hostip'
        //   }
        // },
        // {
        //   dataIndex: 'time_local',
        //   title: '请求时间',
        //   width: 160,
        //   scopedSlots: {
        //     customRender: 'timeLocal'
        //   }
        // },
        {
          dataIndex: 'name',
          title: '数据交换任务名',
          width: 160,
          key: 'name',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'name'
          }
        },
        {
          dataIndex: 'amount',
          title: '交换数据量',
          width: 120,
          scopedSlots: {
            customRender: 'amount'
          }
        },
        {
          dataIndex: 'run_at',
          title: '交换任务开始时间',
          width: 160,
          scopedSlots: {
            customRender: 'runAt'
          }
        },
        {
          dataIndex: 'finished_at',
          title: '交换任务结束时间',
          width: 160,
          scopedSlots: {
            customRender: 'finishedAt'
          }
        },
        {
          dataIndex: 'sync_status',
          title: '数据同步状态',
          width: 160,
          key: 'sync_status',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'syncStatus'
          }
        },
        {
          dataIndex: 'push_status',
          title: '数据推送状态',
          width: 160,
          key: 'push_status',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'pushStatus'
          }
        },
        {
          dataIndex: 'feedback_status',
          title: '数据反馈状态',
          width: 160,
          key: 'feedback_status',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'feedbackStatus'
          }
        }
      ]
    }
  }
}
</script>

<style lang="less">
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
